import React from 'react';

class Classroom extends React.Component {
  domain = '8x8.vc'
  api = {}

  constructor (props) {
    super(props)
    this.state = {
      room : props.computedMatch.params.classcode,
      user: {
        name: props.computedMatch.params.username,
      }
    }
  }

  joinClassroomMeet () {
    const options = {
      roomName: this.state.room,
      width: '100%',
      height: '100%',
      configOverwrite: { prejoinPageEnabled: false },
      interfaceConfigOverwrite: {},
      parentNode: document.querySelector('#jitsi-iframe'),
      userInfo: {
        displayName: this.state.user.name
      }
    }

    this.api = new window.JitsiMeetExternalAPI(this.domain, options);
  }

  componentWillMount () {
    document.body.style.padding = "0";
    document.body.style.margin = "0";
  }

  componentDidMount () {
    console.log('Joining...')
    this.joinClassroomMeet()
  }

  render () {
    return (
      <>
        <div id="jitsi-iframe" style={{width: '100%', height: '100vh'}}></div>
      </>
    )
  }
}

export default Classroom;